export default [
    {
        path: '/costos/mantenimiento/personal-jerarquia',
        name: 'costos-personal-jerarquia',
        component: () =>
            import ('@/views/pages/costos/mantenimiento/PersonalJerarquia.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Costos',
            action: 'ver-costos-personal-jerarquia',
            pageTitle: 'Personal por jerarquía',
            breadcrumb: [
                {
                    text: 'Costos',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Listado personal por jerarquía',
                    active: true,
                },
            ],
        },
    },
]
